// Ticket 20: Matches API - Who Liked You + List Matches
import api from "./client";

const API_BASE = window.location.origin;

/**
 * Fetch all matches for the current user
 * Returns array of match objects with match_id and profile
 */
export async function listMatches() {
  const res = await api.get("/matches");
  return res.data;
}

/**
 * Fetch who liked the current user (Elite feature)
 * Returns { profiles: [], locked: false } on success
 * Returns { profiles: [], locked: true } on 403 (Elite gate)
 * Throws on other errors
 */
export async function fetchWhoLikedMe() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/matches/who-liked-me`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  
  // Handle 403 gracefully - Elite feature locked
  if (res.status === 403) {
    return { profiles: [], locked: true, message: 'Elite feature' };
  }
  
  if (!res.ok) {
    throw new Error('Failed to fetch who liked me');
  }
  
  const data = await res.json();
  return { profiles: data, locked: false };
}
